import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { TextWithLinkPdf } from '@doltech/ui/lib/figma/Layout/Landing/Content/TextWithLinkPdf';

const PromoteSection = styled.div`
  padding: 24px 32px;
`;

const PromoteLandingSection = styled(PromoteSection)`
  background-color: ${colorsV2.yellow20};
  border: 1px solid ${colorsV2.yellow5};
`;

export const PromoteIELTSLandingSection = ({ title, url }) => (
  <PromoteLandingSection>
    <TextWithLinkPdf
      link={url}
      variant="semi-bold/48"
      content={
        <Typography.Text variant="regular/20-32">
          Hãy cùng DOL khám phá kho đề thi{' '}
          <Typography.Text variant="medium/20-32">{title}</Typography.Text> với lời giải thích chi
          tiết ở đây -&gt;
        </Typography.Text>
      }
    />
  </PromoteLandingSection>
);

export const PromoteIELTSVocabLandingSection = ({ title, url }) => (
  <PromoteLandingSection>
    <TextWithLinkPdf
      link={url}
      variant="semi-bold/48"
      content={
        <Typography.Text variant="regular/20-32">
          Hãy cùng DOL khám phá kho vocab{' '}
          <Typography.Text variant="medium/20-32">{title}</Typography.Text> đầy đủ ở đây -&gt;
        </Typography.Text>
      }
    />
  </PromoteLandingSection>
);
